export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 mb-10">
            <div>
              <h3 className="font-heading text-xl text-primary-500 font-bold mb-3">
                悟空影视
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                悟空影视电影大全涵盖悟空影视最新电影、动作片、喜剧片等海量题材。高清画质免费在线观看，无需缓冲即点即播，从经典到新片一应俱全。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-3">快速导航</h4>
              <div className="flex flex-col gap-2">
                {['最新动态', '精选推荐', '话题热榜', '影片索引'].map((label) => (
                  <a
                    key={label}
                    href={`#${label === '最新动态' ? 'updates' : label === '精选推荐' ? 'media' : label === '话题热榜' ? 'topics' : 'index'}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-3">热门分类</h4>
              <div className="flex flex-col gap-2">
                {['动作片', '喜剧片', '科幻片', '悬疑片', '爱情片'].map((cat) => (
                  <span key={cat} className="text-sm text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors duration-200">
                    {cat}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-3">合作伙伴</h4>
              <p className="text-xs text-foreground-500">更多合作伙伴即将加入，敬请期待。</p>
            </div>
          </div>

          <div className="border-t border-background-200/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 悟空影视 wukongmovie.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-500">高清免费在线观影平台</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}